import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "p-3 position-relative" }
const _hoisted_4 = { class: "row m-0" }
const _hoisted_5 = {
  key: 0,
  class: "col border border-5 border-white-and-rounded bg-light-warning d-flex align-items-center p-4 rounded-2"
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"35%"},
  class: "svg-icon svg-icon-3x svg-icon-warning d-block my-2 col-md-3 mr-3"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-building fs-3x text-warning" })
], -1)
const _hoisted_8 = { class: "col mt-5" }
const _hoisted_9 = {
  key: 1,
  class: "col border border-5 border-white-and-rounded bg-light-primary d-flex align-items-center p-4 rounded-2"
}
const _hoisted_10 = { class: "row" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"35%"},
  class: "svg-icon svg-icon-3x svg-icon-primary d-block my-2 col-md-3 mr-3"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-hotel fs-3x text-primary" })
], -1)
const _hoisted_12 = { class: "col mt-5" }
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "col border border-5 border-white-and-rounded bg-light-success d-flex align-items-center p-4 rounded-2" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"35%"},
  class: "svg-icon svg-icon-3x svg-icon-success d-block my-2 col-md-3 mr-3"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-book fs-3x text-success" })
], -1)
const _hoisted_17 = { class: "col mt-5" }
const _hoisted_18 = { class: "col border border-5 border-white-and-rounded bg-light-danger d-flex align-items-center p-4 rounded-2" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"35%"},
  class: "d-block my-2 col-md-3 mr-4"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chalkboard-teacher fs-3x text-danger" })
], -1)
const _hoisted_21 = { class: "col mt-5 ml-1" }
const _hoisted_22 = ["href"]
const _hoisted_23 = { class: "col border border-5 border-white-and-rounded bg-light-success d-flex align-items-center p-4 rounded-2" }
const _hoisted_24 = { class: "row" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"35%"},
  class: "svg-icon svg-icon-3x svg-icon-success d-block my-2 col-md-3 mr-3"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-tie fs-3x text-success" })
], -1)
const _hoisted_26 = { class: "col mt-5" }
const _hoisted_27 = ["href"]
const _hoisted_28 = { class: "card mt-6" }
const _hoisted_29 = { class: "card-body p-0" }
const _hoisted_30 = { class: "p-3 position-relative" }
const _hoisted_31 = { class: "row m-0" }
const _hoisted_32 = { class: "col border border-5 border-white-and-rounded bg-light-warning d-flex align-items-center p-4 rounded-2" }
const _hoisted_33 = { class: "row" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"35%"},
  class: "svg-icon svg-icon-3x svg-icon-warning d-block my-2 col-md-3 mr-3"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-running fs-3x text-warning" })
], -1)
const _hoisted_35 = { class: "col mt-5" }
const _hoisted_36 = { class: "col border border-5 border-white-and-rounded bg-light-primary d-flex align-items-center p-4 rounded-2" }
const _hoisted_37 = { class: "row" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"35%"},
  class: "svg-icon svg-icon-3x svg-icon-primary d-block my-2 col-md-3 mr-3"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-id-card fs-3x text-primary" })
], -1)
const _hoisted_39 = { class: "col mt-5" }
const _hoisted_40 = { class: "col border border-5 border-white-and-rounded bg-light-success d-flex align-items-center p-4 rounded-2" }
const _hoisted_41 = { class: "row" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"35%"},
  class: "svg-icon svg-icon-3x svg-icon-success d-block my-2 col-md-3 mr-3"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-house-user fs-3x text-success" })
], -1)
const _hoisted_43 = { class: "col mt-5" }
const _hoisted_44 = { class: "col border border-5 border-white-and-rounded bg-light-danger d-flex align-items-center p-4 rounded-2" }
const _hoisted_45 = { class: "row" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"35%"},
  class: "d-block my-2 col-md-3 mr-4"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-graduate fs-3x text-danger" })
], -1)
const _hoisted_47 = { class: "col mt-5 ml-1" }
const _hoisted_48 = { class: "col border border-5 border-white-and-rounded bg-light-success d-flex align-items-center p-4 rounded-2" }
const _hoisted_49 = { class: "row" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"35%"},
  class: "svg-icon svg-icon-3x svg-icon-success d-block my-2 col-md-3 mr-3"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-tie fs-3x text-success" })
], -1)
const _hoisted_51 = { class: "col mt-5" }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = /*#__PURE__*/_createStaticVNode("<div class=\"fw-bold\"><div class=\"fs-4 text-gray-600\"><div class=\"mt-4 mb-3\"><p class=\"text-info\"><b class=\"text-primary\"><i class=\"text-info fas fa-hourglass\" aria-hidden=\"true\"></i></b> Waiting for Approval </p></div></div></div>", 1)
const _hoisted_54 = { class: "card mt-5" }
const _hoisted_55 = { class: "card-body p-0" }
const _hoisted_56 = { class: "p-3 position-relative" }
const _hoisted_57 = {
  key: 0,
  class: "row m-0"
}
const _hoisted_58 = { class: "col-md-3 col-4 border border-5 border-white-and-rounded bg-light-warning d-flex align-items-center p-4 rounded-2" }
const _hoisted_59 = { class: "row" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"35%"},
  class: "svg-icon svg-icon-3x svg-icon-warning d-block my-2 col-md-3 mr-3"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-building fs-3x text-warning" })
], -1)
const _hoisted_61 = { class: "col mt-5" }
const _hoisted_62 = { class: "col-md-3 col-4 border border-5 border-white-and-rounded bg-light-primary d-flex align-items-center p-4 rounded-2" }
const _hoisted_63 = { class: "row" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"35%"},
  class: "d-block my-2 col-md-3 mr-4"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-hotel fs-3x text-primary" })
], -1)
const _hoisted_65 = { class: "col mt-5 ml-1" }
const _hoisted_66 = { class: "col-md-3 col-4 border border-5 border-white-and-rounded bg-light-success d-flex align-items-center p-4 rounded-2" }
const _hoisted_67 = { class: "row" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"35%"},
  class: "svg-icon svg-icon-3x svg-icon-success d-block my-2 col-md-3 mr-3"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-book fs-3x text-success" })
], -1)
const _hoisted_69 = { class: "col mt-5" }
const _hoisted_70 = {
  key: 0,
  class: "col-md-3 col-4 border border-5 border-white-and-rounded bg-light-primary d-flex align-items-center p-4 rounded-2"
}
const _hoisted_71 = { class: "row" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"35%"},
  class: "d-block my-2 col-md-3 mr-4"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user fs-3x text-primary" })
], -1)
const _hoisted_73 = { class: "col mt-5 ml-1" }
const _hoisted_74 = { class: "row m-0" }
const _hoisted_75 = { class: "col-md-3 bg-light-success d-flex align-items-center p-4 rounded-2" }
const _hoisted_76 = { class: "row" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"35%"},
  class: "d-block my-2 col-md-3 mr-4"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-tie fs-3x text-success" })
], -1)
const _hoisted_78 = { class: "col mt-5 ml-1" }
const _hoisted_79 = { key: 1 }
const _hoisted_80 = {
  key: 0,
  class: "fw-bold"
}
const _hoisted_81 = /*#__PURE__*/_createStaticVNode("<div class=\"fs-4 text-gray-600\"><div class=\"mt-4 mb-3\"><p class=\"text-info\"><b class=\"text-primary\"><i class=\"text-info fas fa-hourglass\" aria-hidden=\"true\"></i></b> Waiting for Approval From Training Partner </p></div></div>", 1)
const _hoisted_82 = [
  _hoisted_81
]
const _hoisted_83 = {
  key: 1,
  class: "card mt-5"
}
const _hoisted_84 = { class: "card-body p-0" }
const _hoisted_85 = { class: "p-3 position-relative" }
const _hoisted_86 = { class: "row mt-4 m-0" }
const _hoisted_87 = { class: "col bg-light-success d-flex align-items-center p-4 rounded-2" }
const _hoisted_88 = { class: "row" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"35%"},
  class: "d-block my-2 col-md-3 mr-4"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-tie fs-3x text-success" })
], -1)
const _hoisted_90 = { class: "col mt-5 ml-1" }
const _hoisted_91 = {
  key: 2,
  class: "fw-bold"
}
const _hoisted_92 = /*#__PURE__*/_createStaticVNode("<div class=\"fs-4 text-gray-600\"><div class=\"mt-4 mb-3\"><p class=\"text-warning\"><b class=\"text-warning\"><i class=\"text-warning fas fa-clock fs-5\"></i></b> Waiting for Approval From SEIP </p></div></div>", 1)
const _hoisted_93 = [
  _hoisted_92
]
const _hoisted_94 = {
  key: 3,
  class: "card mt-5"
}
const _hoisted_95 = { class: "card-body p-0" }
const _hoisted_96 = { class: "p-3 position-relative" }
const _hoisted_97 = { class: "row m-0" }
const _hoisted_98 = { class: "col-md-3 col-6 border border-5 border-white-and-rounded bg-light-warning d-flex align-items-center p-4 rounded-2" }
const _hoisted_99 = { class: "row" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"35%"},
  class: "svg-icon svg-icon-3x svg-icon-warning d-block my-2 col-md-3 mr-3"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-building fs-3x text-warning" })
], -1)
const _hoisted_101 = { class: "col mt-5" }
const _hoisted_102 = { class: "col-md-3 col-6 border border-5 border-white-and-rounded bg-light-primary d-flex align-items-center p-4 rounded-2" }
const _hoisted_103 = { class: "row" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"35%"},
  class: "d-block my-2 col-md-3 mr-4"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-hotel fs-3x text-primary" })
], -1)
const _hoisted_105 = { class: "col mt-5 ml-1" }
const _hoisted_106 = { class: "col-md-3 col-6 border border-5 border-white-and-rounded bg-light-success d-flex align-items-center p-4 rounded-2" }
const _hoisted_107 = { class: "row" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"35%"},
  class: "svg-icon svg-icon-3x svg-icon-success d-block my-2 col-md-3 mr-3"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-book fs-3x text-success" })
], -1)
const _hoisted_109 = { class: "col mt-5" }
const _hoisted_110 = { class: "col-md-3 col-6 border border-5 border-white-and-rounded bg-light-primary d-flex align-items-center p-4 rounded-2" }
const _hoisted_111 = { class: "row" }
const _hoisted_112 = /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"35%"},
  class: "d-block my-2 col-md-3 mr-4"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user fs-3x text-primary" })
], -1)
const _hoisted_113 = { class: "col mt-5 ml-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_ctx.entity_type_id === '1004')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _createElementVNode("h4", _hoisted_8, _toDisplayString(_ctx.association_count), 1),
                    _createVNode(_component_router_link, {
                      to: "/association/entity-list",
                      class: "text-dark fw-bold fs-6 mt-2"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Training Partners ")
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.entity_type_id != '1011')
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("h4", _hoisted_12, _toDisplayString(_ctx.training_institute_count), 1),
                    _createElementVNode("a", {
                      href: `${this.VUE_APP_TMS}/report/status-monitoring-report`,
                      target: "_blank",
                      class: "text-dark fw-bold fs-6 mt-2"
                    }, "Institutes", 8, _hoisted_13)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("h4", _hoisted_17, _toDisplayString(_ctx.course_count), 1),
                (_ctx.entity_type_id === '1004')
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: "/course-settings/course-alias",
                      class: "text-dark fw-bold fs-6 mt-2"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Courses")
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_router_link, {
                      key: 1,
                      to: "/course/course-list",
                      class: "text-dark fw-bold fs-6 mt-2"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Courses")
                      ]),
                      _: 1
                    }))
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("h4", _hoisted_21, _toDisplayString(_ctx.trainer_count), 1),
                _createElementVNode("a", {
                  href: `${this.VUE_APP_TMS}/report/status-monitoring-report`,
                  target: "_blank",
                  class: "text-dark fw-bold fs-6 mt-2"
                }, "Trainers", 8, _hoisted_22)
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("h4", _hoisted_26, _toDisplayString(_ctx.assessor_count), 1),
                _createElementVNode("a", {
                  href: `${this.VUE_APP_TMS}/report/status-monitoring-report`,
                  target: "_blank",
                  class: "text-dark fw-bold fs-6 mt-2"
                }, "Assessors", 8, _hoisted_27)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _hoisted_34,
                _createElementVNode("h4", _hoisted_35, _toDisplayString(_ctx.running_batch), 1),
                _createVNode(_component_router_link, {
                  to: "/running-batch-list",
                  class: "text-dark fw-bold fs-6 mt-2"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Running Batchs")
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                _createElementVNode("h4", _hoisted_39, _toDisplayString(_ctx.pending_enrollment), 1),
                _createVNode(_component_router_link, {
                  to: "/pending-enrollment-list",
                  class: "text-dark fw-bold fs-6 mt-2"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Pending Enrollments")
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _hoisted_42,
                _createElementVNode("h4", _hoisted_43, _toDisplayString(_ctx.pending_attendance), 1),
                _createVNode(_component_router_link, {
                  to: "/pending-attendance-list",
                  class: "text-dark fw-bold fs-6 mt-2"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Pending Attendances")
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _hoisted_46,
                _createElementVNode("h4", _hoisted_47, _toDisplayString(_ctx.pending_assessment), 1),
                _createVNode(_component_router_link, {
                  to: "/pending-assessment-list",
                  class: "text-dark fw-bold fs-6 mt-2"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Pending Asssessments")
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                _hoisted_50,
                _createElementVNode("h4", _hoisted_51, _toDisplayString(_ctx.pending_employment), 1),
                _createVNode(_component_router_link, {
                  to: "/pending-employment-list",
                  class: "text-dark fw-bold fs-6 mt-2"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Pending Employments")
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ])
    ]),
    ((_ctx.entity_type_id == 1004 && _ctx.userRole =='Admin') || _ctx.entity_type_id ==1011)
      ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
          _hoisted_53,
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("div", _hoisted_56, [
                (_ctx.entity_type_id == 1004)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                      _createElementVNode("div", _hoisted_58, [
                        _createElementVNode("div", _hoisted_59, [
                          _hoisted_60,
                          _createElementVNode("h4", _hoisted_61, _toDisplayString(_ctx.pending_entity_count), 1),
                          _createVNode(_component_router_link, {
                            to: "/association-list",
                            class: "text-dark fw-bold fs-6 mt-2"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Pending Training Partners ")
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_62, [
                        _createElementVNode("div", _hoisted_63, [
                          _hoisted_64,
                          _createElementVNode("h4", _hoisted_65, _toDisplayString(_ctx.pending_institute_count), 1),
                          _createVNode(_component_router_link, {
                            to: "/institute-list",
                            class: "text-dark fw-bold fs-6 mt-2"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Pending Institutes")
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_66, [
                        _createElementVNode("div", _hoisted_67, [
                          _hoisted_68,
                          _createElementVNode("h4", _hoisted_69, _toDisplayString(_ctx.pending_course_count), 1),
                          _createVNode(_component_router_link, {
                            to: "/course-list",
                            class: "text-dark fw-bold fs-6 mt-2"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Pending Courses")
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      (_ctx.entity_type_id == 1004)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                            _createElementVNode("div", _hoisted_71, [
                              _hoisted_72,
                              _createElementVNode("h4", _hoisted_73, _toDisplayString(_ctx.pending_trainning_target_count), 1),
                              _createVNode(_component_router_link, {
                                to: "/pending-target",
                                class: "text-dark fw-bold fs-6 mt-2"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Pending Entity Targets")
                                ]),
                                _: 1
                              })
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_74, [
                  _createElementVNode("div", _hoisted_75, [
                    _createElementVNode("div", _hoisted_76, [
                      _hoisted_77,
                      _createElementVNode("h4", _hoisted_78, _toDisplayString(_ctx.pendingInstituteTarget), 1),
                      _createVNode(_component_router_link, {
                        to: "/pending-institute-target",
                        class: "text-dark fw-bold fs-6 mt-2"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Pending Institute Targets")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.entity_type_id > 1004 && _ctx.entity_type_id != 1011)
      ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
          (_ctx.adminPermission)
            ? (_openBlock(), _createElementBlock("div", _hoisted_80, _hoisted_82))
            : _createCommentVNode("", true),
          (_ctx.adminPermission)
            ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                _createElementVNode("div", _hoisted_84, [
                  _createElementVNode("div", _hoisted_85, [
                    _createElementVNode("div", _hoisted_86, [
                      _createElementVNode("div", _hoisted_87, [
                        _createElementVNode("div", _hoisted_88, [
                          _hoisted_89,
                          _createElementVNode("h4", _hoisted_90, _toDisplayString(_ctx.pendingInstituteTarget), 1),
                          _createVNode(_component_router_link, {
                            to: "/pending-institute-target",
                            class: "text-dark fw-bold fs-6 mt-2"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Pending Institute Targets")
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.adminPermission)
            ? (_openBlock(), _createElementBlock("div", _hoisted_91, _hoisted_93))
            : _createCommentVNode("", true),
          (_ctx.adminPermission)
            ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                _createElementVNode("div", _hoisted_95, [
                  _createElementVNode("div", _hoisted_96, [
                    _createElementVNode("div", _hoisted_97, [
                      _createElementVNode("div", _hoisted_98, [
                        _createElementVNode("div", _hoisted_99, [
                          _hoisted_100,
                          _createElementVNode("h4", _hoisted_101, _toDisplayString(_ctx.pending_entity_count), 1),
                          _createVNode(_component_router_link, {
                            to: "/association-list",
                            class: "text-dark fw-bold fs-6 mt-2"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Pending Training Partners ")
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_102, [
                        _createElementVNode("div", _hoisted_103, [
                          _hoisted_104,
                          _createElementVNode("h4", _hoisted_105, _toDisplayString(_ctx.pending_institute_count), 1),
                          _createVNode(_component_router_link, {
                            to: "/institute-list",
                            class: "text-dark fw-bold fs-6 mt-2"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Pending Institutes")
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_106, [
                        _createElementVNode("div", _hoisted_107, [
                          _hoisted_108,
                          _createElementVNode("h4", _hoisted_109, _toDisplayString(_ctx.pending_course_count), 1),
                          _createVNode(_component_router_link, {
                            to: "/course-list",
                            class: "text-dark fw-bold fs-6 mt-2"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Pending Courses")
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_110, [
                        _createElementVNode("div", _hoisted_111, [
                          _hoisted_112,
                          _createElementVNode("h4", _hoisted_113, _toDisplayString(_ctx.pending_trainning_target_count), 1),
                          _createVNode(_component_router_link, {
                            to: "/pending-target",
                            class: "text-dark fw-bold fs-6 mt-2"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Pending Entity Targets")
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}